module.exports = __webpack_public_path__ + "media/images/s01_07-cf16584fae8ab5448ec61cecbea057d4.svg";